import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';

import { AppComponent } from 'src/app/app.component';
import { MainComponent } from '../../main/main.component';
import { environment } from 'src/environments/environment';

import { MapComponent, MapLatLng } from 'movisat-maps';
import { MapItinerary } from 'movisat-maps';

import { SsoService } from 'src/app/services/sso/sso.service';
import { WindowComponent } from 'movisat-common-gui';

@Component({
  selector: 'app-itinerari',
  templateUrl: './itinerari.component.html',
  styleUrls: ['./itinerari.component.css']
})
export class ItinerariComponent implements OnInit {
  @ViewChild('ventana') public ventana: WindowComponent;
  @ViewChild('inputIni') public inputIni: ElementRef;
  @ViewChild('inputFin') public inputFin: ElementRef;

  public static _this: ItinerariComponent;

  private map: MapComponent;
  private componentRef = null;
  public environment = environment;
  private subscriptionOnMapClick = null;
  private subscriptionOnMarkerClick = null;
  private fromTab = 0;
  private inputFocus: string = 'inicio';
  private itinerary: MapItinerary;
  private position: MapLatLng;

  constructor(private ssoService: SsoService) {
    ItinerariComponent._this = this;
  }

  ngOnInit(): void {
    this.map = MainComponent.getActiveMap();
  }

  async ngAfterViewInit(): Promise<void> {
    this.subscribeMapEvents();

    document.getElementById('itiIni').focus();
    this.itinerary = this.map.itinerary({
      fromInput: 'itiIni',
      toInput: 'itiFin',
      resultDiv: 'itineraryInfo'
    });
  }

  // Este método es llamado por el creador del componente
  public init(componentRef: any, tab: number) {
    this.componentRef = componentRef;
    this.fromTab = tab;
  }

  // Para traducir los textos
  public translate(text: string): string {
    return AppComponent.translate(text);
  }

  // Cierro el formulario y destruyo el componente
  public onClose() {
    document.getElementById('itiIni').remove();
    document.getElementById('itiFin').remove();
    if (this.itinerary) {
      this.map.removeItineary(this.itinerary);
    }
    if (this.subscriptionOnMapClick) {
      this.subscriptionOnMapClick.unsubscribe();
      this.subscriptionOnMapClick = null;
    }

    if (this.subscriptionOnMarkerClick) {
      this.subscriptionOnMarkerClick.unsubscribe();
    }
    this.subscriptionOnMarkerClick = null;
    // this.map.setMousePointer('');
    MainComponent.getInstance().setFormItineraryVisible(false);
    setTimeout(() => {
      MainComponent.getInstance().tabGestion.selectAt(this.fromTab);
    }, 500);
    if (this.componentRef) {
      this.componentRef.destroy();
    }

    ItinerariComponent._this = null;

    MainComponent.getInstance().shouldCloseRightSplitter();
  }

  // Me subscrivo a eventos del mapa
  subscribeMapEvents() {
    this.subscriptionOnMapClick = this.map.subscribeOnMapClick(this, this.onConstructorItinerari.bind(this));
    this.subscriptionOnMarkerClick = this.map.subscribeOnMarkerClick(this, this.onConstructorItinerari.bind(this));
  }

  onConstructorItinerari(_this: ItinerariComponent, marker: any) {
    if (marker.position !== undefined) {
      this.position = marker.position;
    } else if (marker) {
      this.position = marker;
    }
    const point = _this.map.latLngToScreenPoint(_this.position);
    const newPosition = _this.map.screenPointToLatLng(point);

    let elem;

    if (this.inputIni.nativeElement.value === '' && this.inputFocus !== 'destino') {
      elem = document.getElementById('itiIni');
      elem.value = _this.translate('Punto') + ' A';
      this.itinerary.setOrigen(newPosition);
      this.inputFocus = 'destino';
    } else {
      elem = document.getElementById('itiFin');
      elem.value = _this.translate('Punto') + ' B';
      this.itinerary.setDestino(newPosition);
      this.inputFocus = 'inicio';
    }
    if (_this.itinerary.getOrigen() && _this.itinerary.getDestino()) {
      MainComponent.getInstance().setFormItineraryVisible(true);
      this.itinerary.calcItinerary();
    }
  }

  onOrigenFocus(event: any) {
    const elem: any = document.getElementById('itiIni');
    elem.value = '';
    this.inputFocus = 'inicio';
  }

  onDestinoFocus(event: any) {
    const elem: any = document.getElementById('itiFin');
    elem.value = '';
    this.inputFocus = 'destino';
  }

  onAlternar(event: any) {
    const elemOri: any = document.getElementById('itiIni');
    const elemDest: any = document.getElementById('itiFin');
    let oriText = elemOri.value;
    let destText = elemDest.value;
    if (oriText !== this.translate('Punto') + ' A' || destText !== this.translate('Punto') + ' B') {
      if (oriText === this.translate('Punto') + ' A') {
        oriText = this.translate('Punto') + ' B';
      } else {
        if (oriText === this.translate('Punto') + ' B') {
          oriText = this.translate('Punto') + ' A';
        }
      }
      if (destText === this.translate('Punto') + ' A') {
        destText = this.translate('Punto') + ' B';
      } else {
        if (destText === this.translate('Punto') + ' B') {
          destText = this.translate('Punto') + ' A';
        }
      }
      elemOri.value = destText;
      elemDest.value = oriText;
    }
    const ori = this.itinerary.getOrigen();
    const dest = this.itinerary.getDestino();
    if (ori && dest) {
      this.itinerary.setOrigen(dest);
      this.itinerary.setDestino(ori);
      this.itinerary.calcItinerary();
    }
  }
}
